import React, { useState } from 'react';
import {
    VerticalTimeline,
    VerticalTimelineElement
} from 'react-vertical-timeline-component';

import styles from './TimeLine.module.scss'

import 'react-vertical-timeline-component/style.min.css';
import DateFormat from '../dateFormat/dateFormat';
import { DATE_TIME_FORMAT_DEFAULT } from 'Config';
import ReactTooltip from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import AvatarWithText from '../avatar/AvatarWithText';
import colors from 'styles/export/colors.module.scss';
import { ChargesStatusColorEnum } from 'api/charges/enums/ChargesStatusColorEnum';
import InputResizable from '../input/InputResizable';
import CustomFile from 'common/models/CustomFile';
import FileSelector from '../fileSelector/FileSelector';
import { RequestStatusType, SituationType } from 'screens/vehicle/components/carChargeTab/components/ChargeScreen';

export interface TimeLineItem {
    title?: string | React.ReactElement;
    date?: Date;
    dateRefund?: Date;
    createdDate?: Date;
    userName?: string;
    userPhotoUrl?: string;
    description?: string;
    message?: string;
    email_to?: string;
    email_cc?: string;
    subject?: string;
    status?: string;
    situation?: string;
    refundAttachments: CustomFile[];
    dateFormat?: string;
}
export type Props = {
    items?: TimeLineItem[];
    emailTemplate?: boolean;

} & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const TimeLine = ({ items, emailTemplate }: Props) => {
    const { t } = useTranslation();
    const [expandedItems, setExpandedItems] = useState<number[]>([]);

    const toggleExpand = (index: number) => {
        setExpandedItems(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    return (
        <VerticalTimeline
            animate={false}
            layout={'1-column'}
        >
            {items && items.length > 0 && items.map((item, i) => {
                let backgroundColor = colors.black;

                if (item.status && item.status == RequestStatusType.REFUSED) {
                    backgroundColor = (ChargesStatusColorEnum as any)[item.status];
                } else if (item.situation && item.situation == SituationType.TREATED) {
                    backgroundColor = (ChargesStatusColorEnum as any)[item.situation];
                }

                const isExpanded = expandedItems.includes(i);

                return (
                    <VerticalTimelineElement
                        key={`item_${i}`}
                        iconStyle={{
                            background: backgroundColor,
                            color: '#fff'
                        }}
                    >
                        <div>
                            <span className={styles.title}>
                                {item.title}
                            </span>

                            <span className={styles.infoSmall}>
                                {!Boolean(item.dateRefund) && Boolean(item.date) &&
                                    <>
                                        <span data-tip={t('charges.date_refund_tooltip')}>
                                            <DateFormat value={item.date ?? ''} format={item.dateFormat ?? DATE_TIME_FORMAT_DEFAULT.toString()} />
                                        </span>
                                        <ReactTooltip />
                                    </>
                                }
                                {Boolean(item.dateRefund) &&
                                    <>
                                        <span data-tip={t('charges.date_tooltip')}>
                                            <DateFormat value={item.dateRefund ?? ''} format={DATE_TIME_FORMAT_DEFAULT.toString()} />
                                        </span>
                                        <ReactTooltip />
                                    </>
                                }
                                {Boolean(item.createdDate) &&
                                    <>
                                        <span>
                                            <DateFormat value={item.createdDate ?? ''} format={DATE_TIME_FORMAT_DEFAULT.toString()} />
                                        </span>
                                        <ReactTooltip />
                                    </>
                                }
                            </span>
                        </div>

                        <div className={styles.info}>
                            <AvatarWithText src={item.userPhotoUrl} size="x2"><span style={{ wordBreak: 'break-word', maxWidth: '90%' }}>{item.userName}</span></AvatarWithText>
                        </div>
                        {item.description && <div className={styles.info} >

                            <InputResizable
                                style={{ backgroundColor: '#F7F7F7', border: 'none', padding: '0.5rem' }}
                                value={item.description}
                            />
                        </div>}


                        {/* Botão para expandir */}
                        { emailTemplate && <div style={{ marginTop: '0.5rem' }}>
                            <span className={styles.showMore} onClick={e => {
                                e.stopPropagation();
                                toggleExpand(i)
                            }}>
                                <span> {isExpanded ? t('common.view_less') : t('common.view_all')}</span>
                            </span>

                        </div>}

                        {/* Conteúdo do e-mail (só aparece se expandido) */}
                        {emailTemplate && isExpanded && (
                            <div>
                                {item.email_to && <div className={styles.info} style={{ marginTop: '0.5rem' }}><span style={{ fontWeight: 'bold' }}>{t('common.email_to') + ': '}</span>{item.email_to}</div>}
                                {item.email_cc && <div className={styles.info}><span style={{ fontWeight: 'bold' }}>{t('common.email_cc') + ': '}</span>{item.email_cc}</div>}
                                {item.subject && <div className={styles.info}><span style={{ fontWeight: 'bold' }}>{t('notifications.subject') + ': '}</span>{item.subject}</div>}
                                {item.message && <div className={styles.info} style={{ marginTop: '0.5rem' }}><span style={{ fontWeight: 'bold' }}>{t('notifications.message') + ': '}</span> <div className={styles.message} dangerouslySetInnerHTML={{ __html: item.message ?? '' }} /></div>}

                                <div>
                                    <div className={styles.info} style={{ marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: 'bold' }}>{t('common.attachment') + ': '}</span>
                                    </div>
                                    <FileSelector
                                        isDetails={true}
                                        isMulti={true}
                                        initialFiles={item.refundAttachments}
                                        onFilesChanged={() => { console.log() }}
                                        onRemoveFile={() => { console.log() }}
                                        smallButtonAdd={true}
                                        fileButtonSizes={{ sm: 0, md: 0, lg: 0, xl: 0 }}
                                    />
                                </div>
                            </div>)}
                        {!emailTemplate &&
                            <div>
                                <FileSelector
                                    isDetails={true}
                                    isMulti={true}
                                    initialFiles={item.refundAttachments}
                                    onFilesChanged={() => { console.log() }}
                                    onRemoveFile={() => { console.log() }}
                                    smallButtonAdd={true}
                                    fileButtonSizes={{ sm: 0, md: 0, lg: 0, xl: 0 }}
                                />
                            </div>
                        }
                    </VerticalTimelineElement>
                );
            })}
        </VerticalTimeline >
    );
};

export default TimeLine;